/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/api/axiosInstance.js";
import type { FindPromptRewardByIDQueryResponse, FindPromptRewardByIDPathParams, FindPromptRewardByID400, FindPromptRewardByID401, FindPromptRewardByID404, FindPromptRewardByID409, FindPromptRewardByID500 } from "../../types/FindPromptRewardByID.js";
import type { Client, RequestConfig, ResponseErrorConfig } from "@/api/axiosInstance.js";

function getFindPromptRewardByIDUrl(promptRewardID: FindPromptRewardByIDPathParams["promptRewardID"]) {
  const res = { method: 'GET', url: `/api/prompt/${promptRewardID}` as const }
  return res
}

/**
 * @description Retrieves the prompt reward details corresponding to the specified prompt reward ID. Access is restricted based on the resource's scope and the user's permissions.
 * @summary Get Prompt Reward by ID
 * {@link /api/prompt/:promptRewardID}
 */
export async function findPromptRewardByID(promptRewardID: FindPromptRewardByIDPathParams["promptRewardID"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<FindPromptRewardByIDQueryResponse, ResponseErrorConfig<FindPromptRewardByID400 | FindPromptRewardByID401 | FindPromptRewardByID404 | FindPromptRewardByID409 | FindPromptRewardByID500>, unknown>({ method : "GET", url : getFindPromptRewardByIDUrl(promptRewardID).url.toString(), ... requestConfig })
  return res.data
}